export function toRoutingSlug(name: string) {
    if (typeof name !== "string") {
        throw new Error("Input must be a string");
    }
    
    return name
        .toLowerCase() 
        .trim() 
        .replace(/[^a-z0-9\s-]/g, '') 
        .replace(/\s+/g, '-') 
        .replace(/-+/g, '-'); 
}

export function getProductSlug(slug: string, productCode: string) {
    const path = '/' + slug + '/p' + productCode;
    return path
}

export function getCategorySlug(slug: string, id: number) {
    const routeSlug = toRoutingSlug(slug);
    const path = '/' + routeSlug + '/c' + id;

    return path;
}

export function getSubCategorySlug(slug: string, child_slug: string, id: number) {
    const routeSlug = toRoutingSlug(slug);
    const routeChildSlug = toRoutingSlug(child_slug);
    const path = '/' + routeSlug + '/' + routeChildSlug + '/c' + id;

    return path;
}

export function getBrandSlug(slug: string = '', child_slug: string = '') {
    let path = '/merk';
    if (slug) {
        if (slug.includes('%20')) { 
      path += `/${slug}`;
    } else {
      path += `/${toRoutingSlug(slug)}`;
    }
    }

    if (child_slug) {
        path += `/${child_slug}`;
    }

    return path;
}

export function getBranchSlug(slug: string) {
    const routeSlug = toRoutingSlug(slug);
    const path = '/branches/' + routeSlug;

    return path;
}


export function getContentSlug(slug: string) {
    const path = '/content/' + slug;

    return path;
}